/**
 * useAnalytics - Hook exposing trackEvent for custom analytics events
 */

import { useCallback } from 'react';
import { trackEvent as fireEvent } from '../services/analyticsService';

/**
 * Returns a stable trackEvent function that sends to both GTM and Meta Pixel.
 */
export function useAnalytics() {
  const trackEvent = useCallback((eventName, params = {}) => {
    fireEvent(eventName, params);
  }, []);

  return { trackEvent };
}

export default useAnalytics;
